export default {
      id: "published-date-usage",
      viewBox: "0 0 14 15",
      url: __webpack_public_path__ + "sprite.svg#published-date",
      toString: function () {
        return this.url;
      }
    }